const kashika7Options = [
  
    {
        menuName: "インフラツーリズムマップ",
        activateAccordion: true,
        options: [
            {
                label: "施設情報",
                type: "marker",
                id: "vis_94",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_SPOT_94,
            }
        ]
    },
    {
        menuName: "自転車道",
        activateAccordion: true,
        useAccordion: true,
        options: [
            {
                label: "大竹市マロンの里コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_1",
                url:process.env.REACT_APP_GEOJSON_101_1,
                color:"#2aa2d6",
            },
            {
                label: "廿日市市浅原コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_2",
                url:process.env.REACT_APP_GEOJSON_101_2,
                color:"#2aa2d6",
            },
            {
                label: "宮島包ケ浦コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_3",
                url:process.env.REACT_APP_GEOJSON_101_3,
                color:"#e85144",
            },
            {
                label: "大元公園宮島散走コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_4",
                url:process.env.REACT_APP_GEOJSON_101_4,
                color:"#2aa2d6",
            },
            {
                label: "湯来グルメコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_5",
                url:process.env.REACT_APP_GEOJSON_101_5,
                color:"#e85144",
            },
            {
                label: "かかしの里コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_6",
                url:process.env.REACT_APP_GEOJSON_101_6,
                color:"#7ecd3d",
            },
            {
                label: "湯めぐりコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_7",
                url:process.env.REACT_APP_GEOJSON_101_7,
                color:"#2aa2d6",
            },
            {
                label: "かわなみサイクリングロード",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_8",
                url:process.env.REACT_APP_GEOJSON_101_8,
                color:"#e85144",
            },
            {
                label: "世界遺産ルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_9",
                url:process.env.REACT_APP_GEOJSON_101_9,
                color:"#e85144",
            },
            {
                label: "福富コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_10",
                url:process.env.REACT_APP_GEOJSON_101_10,
                color:"#34ba86",
            },
            {
                label: "豊栄コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_11",
                url:process.env.REACT_APP_GEOJSON_101_11,
                color:"#e57534",
            },
            {
                label: "河内コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_12",
                url:process.env.REACT_APP_GEOJSON_101_12,
                color:"#e57534",
            },
            {
                label: "大崎上島町一日島めぐりコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_13",
                url:process.env.REACT_APP_GEOJSON_101_13,
                color:"#e57534",
            },
            {
                label: "かきしま海道サイクリングロード",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_14",
                url:process.env.REACT_APP_GEOJSON_101_14,
                color:"#34ba86",
            },
            {
                label: "安芸灘とびしま海道ぐるり一周コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_15",
                url:process.env.REACT_APP_GEOJSON_101_15,
                color:"#34ba86",
            },
            {
                label: "竹原市仁賀コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_16",
                url:process.env.REACT_APP_GEOJSON_101_16,
                color:"#34ba86",
            },
            {
                label: "やまがたロングサイクルコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_17",
                url:process.env.REACT_APP_GEOJSON_101_17,
                color:"#e57534",
            },
            {
                label: "三段峡コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_18",
                url:process.env.REACT_APP_GEOJSON_101_18,
                color:"#7ecd3d",
            },
            {
                label: "棚田コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_19",
                url:process.env.REACT_APP_GEOJSON_101_19,
                color:"#7ecd3d",
            },
            {
                label: "高原コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_20",
                url:process.env.REACT_APP_GEOJSON_101_20,
                color:"#2aa2d6",
            },
            {
                label: "テングシデコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_21",
                url:process.env.REACT_APP_GEOJSON_101_21,
                color:"#7ecd3d",
            },
            {
                label: "どんぐりコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_22",
                url:process.env.REACT_APP_GEOJSON_101_22,
                color:"#7ecd3d",
            },
            {
                label: "大朝散走コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_23",
                url:process.env.REACT_APP_GEOJSON_101_23,
                color:"#2aa2d6",
            },
            {
                label: "サンフレッチェ広島練習場コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_24",
                url:process.env.REACT_APP_GEOJSON_101_24,
                color:"#e85144",
            },
            {
                label: "三矢の里一周コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_25",
                url:process.env.REACT_APP_GEOJSON_101_25,
                color:"#7c71b5",
            },
            {
                label: "安芸高田市毛利の里コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_26",
                url:process.env.REACT_APP_GEOJSON_101_26,
                color:"#e57534",
            },
            {
                label: "江の川散策コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_27",
                url:process.env.REACT_APP_GEOJSON_101_27,
                color:"#7ecd3d",
            },
            {
                label: "なつかしい商店街コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_28",
                url:process.env.REACT_APP_GEOJSON_101_28,
                color:"#e85144",
            },
            {
                label: "川西ポタリングコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_29",
                url:process.env.REACT_APP_GEOJSON_101_29,
                color:"#e671a6",
            },
            {
                label: "さくぎアドベンチャーサイクリングコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_30",
                url:process.env.REACT_APP_GEOJSON_101_30,
                color:"#7ecd3d",
            },
            {
                label: "庄原エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_31",
                url:process.env.REACT_APP_GEOJSON_101_31,
                color:"#e671a6",
            },
            {
                label: "西城エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_32",
                url:process.env.REACT_APP_GEOJSON_101_32,
                color:"#e671a6",
            },
            {
                label: "東城・帝釈峡エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_33",
                url:process.env.REACT_APP_GEOJSON_101_33,
                color:"#7ecd3d",
            },
            {
                label: "総領エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_34",
                url:process.env.REACT_APP_GEOJSON_101_34,
                color:"#e671a6",
            },
            {
                label: "高野エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_35",
                url:process.env.REACT_APP_GEOJSON_101_35,
                color:"#e671a6",
            },
            {
                label: "口和エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_36",
                url:process.env.REACT_APP_GEOJSON_101_36,
                color:"#e671a6",
            },
            {
                label: "比和エリアルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_37",
                url:process.env.REACT_APP_GEOJSON_101_37,
                color:"#7c71b5",
            },
            {
                label: "灰塚レイクサイドコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_38",
                url:process.env.REACT_APP_GEOJSON_101_38,
                color:"#7c71b5",
            },
            {
                label: "フルーツ＆千本桜コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_39",
                url:process.env.REACT_APP_GEOJSON_101_39,
                color:"#7c71b5",
            },
            {
                label: "帝釈峡ヒバゴンコース（庄原満喫ルート）",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_40",
                url:process.env.REACT_APP_GEOJSON_101_40,
                color:"#7c71b5",
            },
            {
                label: "中国山河満喫ショートコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_41",
                url:process.env.REACT_APP_GEOJSON_101_41,
                color:"#e85144",
            },
            {
                label: "中国山河満喫コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_42",
                url:process.env.REACT_APP_GEOJSON_101_42,
                color:"#7c71b5",
            },
            {
                label: "中国山地をグルッと1周!道の駅グルメ堪能コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_43",
                url:process.env.REACT_APP_GEOJSON_101_43,
                color:"#7c71b5",
            },
            {
                label: "やまなみフルーツライドコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_44",
                url:process.env.REACT_APP_GEOJSON_101_44,
                color:"#e57534",
            },
            {
                label: "みつぎダムクライムコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_45",
                url:process.env.REACT_APP_GEOJSON_101_45,
                color:"#34ba86",
            },
            {
                label: "芦田湖コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_46",
                url:process.env.REACT_APP_GEOJSON_101_46,
                color:"#2aa2d6",
            },
            {
                label: "世羅ふれあいロードコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_47",
                url:process.env.REACT_APP_GEOJSON_101_47,
                color:"#34ba86",
            },
            {
                label: "さざなみ海道サイクリングロード",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_48",
                url:process.env.REACT_APP_GEOJSON_101_48,
                color:"#e85144",
            },
            {
                label: "三原市佐木島コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_49",
                url:process.env.REACT_APP_GEOJSON_101_49,
                color:"#34ba86",
            },
            {
                label: "瀬戸内しまなみ海道サイクリングロード",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_50",
                url:process.env.REACT_APP_GEOJSON_101_50,
                color:"#34ba86",
            },
            {
                label: "尾道市百島コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_51",
                url:process.env.REACT_APP_GEOJSON_101_51,
                color:"#7c71b5",
            },
            {
                label: "世羅町花めぐりコース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_52",
                url:process.env.REACT_APP_GEOJSON_101_52,
                color:"#e85144",
            },
            {
                label: "福山市田島横島コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_53",
                url:process.env.REACT_APP_GEOJSON_101_53,
                color:"#e671a6",
            },
            {
                label: "しおまち海道コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_54",
                url:process.env.REACT_APP_GEOJSON_101_54,
                color:"#e671a6",
            },
            {
                label: "びんご府中御朱印巡り",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_55",
                url:process.env.REACT_APP_GEOJSON_101_55,
                color:"#2aa2d6",
            },
            {
                label: "上下・世羅ライン",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_56",
                url:process.env.REACT_APP_GEOJSON_101_56,
                color:"#7ecd3d",
            },
            {
                label: "上下・帝釈峡ライン",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_57",
                url:process.env.REACT_APP_GEOJSON_101_57,
                color:"#e57534",
            },
            {
                label: "上下・府中ライン",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_58",
                url:process.env.REACT_APP_GEOJSON_101_58,
                color:"#e671a6",
            },
            {
                label: "上下散走ルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_59",
                url:process.env.REACT_APP_GEOJSON_101_59,
                color:"#2aa2d6",
            },
            {
                label: "天領上下 路地裏ルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_60",
                url:process.env.REACT_APP_GEOJSON_101_60,
                color:"#7c71b5",
            },
            {
                label: "神石高原町高原コース",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_61",
                url:process.env.REACT_APP_GEOJSON_101_61,
                color:"#e671a6",
            },
            {
                label: "上島町ゆめしま海道周遊ルート",
                type: "geojson",
                menuDisplayType: "bgColorCodeAndText",
                id: "vis_101_62",
                url:process.env.REACT_APP_GEOJSON_101_62,
                color:"#e57534",
            },
        ]
    },

];


export  {
    kashika7Options
};
